import {
  mrrByProductResponseSchema,
  mrrSeriesResponseSchema,
  type MrrByProductResponse,
  type MrrSeriesResponse,
} from '@control-center/shared';

import { apiClient } from './api-client';

export interface MrrSeriesParams {
  from?: string;
  to?: string;
  groupBy?: 'day' | 'month';
}

export async function fetchMrrSeries(params: MrrSeriesParams = {}): Promise<MrrSeriesResponse> {
  const qs = new URLSearchParams();
  if (params.from) qs.set('from', params.from);
  if (params.to) qs.set('to', params.to);
  if (params.groupBy) qs.set('groupBy', params.groupBy);
  const suffix = qs.toString();
  const res = await apiClient.get<unknown>(`/api/reports/mrr-series${suffix ? `?${suffix}` : ''}`);
  return mrrSeriesResponseSchema.parse(res.data);
}

export async function fetchMrrByProduct(): Promise<MrrByProductResponse> {
  const res = await apiClient.get<unknown>('/api/reports/mrr-by-product');
  return mrrByProductResponseSchema.parse(res.data);
}

/** Baixa o CSV (endpoint autenticado → fetch via apiClient + Blob). */
export async function downloadMrrCsv(params: { from?: string; to?: string } = {}): Promise<void> {
  const qs = new URLSearchParams();
  if (params.from) qs.set('from', params.from);
  if (params.to) qs.set('to', params.to);
  const suffix = qs.toString();
  const res = await apiClient.get<string>(`/api/reports/export/csv${suffix ? `?${suffix}` : ''}`, {
    responseType: 'text',
  });
  const blob = new Blob([res.data], { type: 'text/csv;charset=utf-8' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = 'mrr-report.csv';
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
}
